/* unplugin-vue-components disabled */import { render } from "./farmManagement.vue?vue&type=template&id=ebb64108&scoped=true"
import script from "./farmManagement.vue?vue&type=script&lang=js"
export * from "./farmManagement.vue?vue&type=script&lang=js"

import "./farmManagement.vue?vue&type=style&index=0&id=ebb64108&lang=scss&scoped=true"

import exportComponent from "D:\\项目\\北国之春\\north\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebb64108"]])

export default __exports__